export default __webpack_public_path__ + "static/media/bd-home-placeholder.5b14bcaa.jpg";